import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { getAuth } from "firebase/auth";

export class UserDropdown extends Component {
  render() {
    const { userDetail } = this.props;
    const auth = getAuth();
    return (
      <li className="dropdown">
        <a
          href="#"
          data-toggle="dropdown"
          className="nav-link dropdown-toggle nav-link-lg nav-link-user"
        >
          <img
            alt="image"
            src={userDetail.userImg}
            className="rounded-circle mr-1"
          />
          <div className="d-sm-none d-lg-inline-block">
            Hi, {userDetail?.details?.userName || userDetail.userName}
          </div>
        </a>
        <div className="dropdown-menu dropdown-menu-right">
          {userDetail.datas.map((data, idata) => {
            return (
              <NavLink
                key={idata}
                to={data.link}
                activeStyle={{
                  color: "#6777ef",
                }}
                exact
                className="dropdown-item has-icon"
              >
                <i className={data.icode} /> {data.title}
              </NavLink>
            );
          })}

          <div className="dropdown-divider" />
          <a
            href="#"
            className="dropdown-item has-icon text-danger"
            onClick={() => {
              auth
                .signOut()
                .then(function() {
                  // Sign-out successful.
                  window.location.reload();
                })
                .catch(function(error) {
                  // An error happened.
                });
            }}
          >
            <i className={userDetail.logoutIcon} /> {userDetail.logoutTitle}
          </a>
        </div>
      </li>
    );
  }
}

export default UserDropdown;
